var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "error404" }, [
    _c(
      "div",
      { staticClass: "error404-body-con" },
      [
        _c("el-card", [
          _c("div", { staticClass: "error404-body-con-title" }, [
            _vm._v("4"),
            _c("span", [_c("i", { attrs: { type: "ios-navigate-outline" } })]),
            _vm._v("4")
          ]),
          _c("p", { staticClass: "error404-body-con-message" }, [
            _vm._v("YOU  LOOK  LOST")
          ]),
          _c(
            "div",
            { staticClass: "error404-btn-con" },
            [
              _c(
                "el-button",
                {
                  staticStyle: { width: "200px" },
                  attrs: { size: "large", type: "text" },
                  on: { click: _vm.goHome }
                },
                [_vm._v("返回首页")]
              ),
              _c(
                "el-button",
                {
                  staticStyle: { width: "200px", "margin-left": "40px" },
                  attrs: { size: "large", type: "primary" },
                  on: { click: _vm.backPage }
                },
                [_vm._v("返回上一页")]
              )
            ],
            1
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }